[
  {
    "backVersion": "25.116.3",
    "frontVersion": 15,
    "date": "1404/02/05",
    "details": [
      "افزودن ماژول اموال به نرم‌افزار",
      "اضافه شدن گزارش «حساب‌های خلاف ماهیت» با تفکیک شناورها",
      "به‌روزرسانی خروجی فایل مالیات حقوق و دستمزد بر اساس آخرین تغییرات اداره دارایی",
      "بهبود قالب چاپ‌های پیش‌فرض و سیستمی در بخش‌های مختلف نرم‌افزار",
      "امکان محاسبه مانده ریالی در گزارش مرور تعدادی کالا",
      "ارائه گزارش «لیست کالاها» با نرخ‌های فروش مختلف"
    ]
  },
  {
    "backVersion": "24.303.1",
    "frontVersion": 15,
    "date": "1403/08/08",
    "details": [
      "اضافه شدن ریز عوامل مبلغی به رسید انبار",
      "اضافه شدن قابلیت انتساب حساب و شناور به انبار",
      "اضافه شدن قابلیت کپی از حکم بر روی پرسنل های انتخابی"
    ]
  },
  {
    "backVersion": "24.239.1",
    "frontVersion": 14,
    "date": "1403/06/05",
    "details": [
      "افزایش سرعت لود شناورهای تفصیلی در حالتی که تعداد شناورها بیش از 1000 آیتم باشد",
      "جدا شدن ستون شناورهای تفصیلی در گزارشات گردش حساب و لیست فاکتور ها",
      "اضافه شدن چاپ گروهی سند ها",
      "فعال شدن فیلتر شناور های تفصیلی در کاردکس کالا",
      "قابلیت فیلتر کالاهای دارای گردش در مرور تعدادی کالا و انبار",
      "اضافه شدن گزارش رهگیری رسید و حواله و فاکتورها"
    ]
  },
  {
    "backVersion": "24.153.1",
    "frontVersion": 13,
    "date": "1403/03/16",
    "details": [
      "اضافه شدن درصد معافیت بیمه به مشمول مالیات پرسنل",
      "سرشکن شدن تخفیف زیر فاکتور بر روی ردیف های فاکتور",
      "قابلیت نمایش مجموع در جداول برای ردیف های انتخاب شده",
      "افزودن دکمه های کمکی در انتخاب دسترسی داده",
      "اضافه شدن سطح دسترسی مانده و گردش به حساب ها و شناورهای تفصیلی",
      "تغییرات در چیدمان منو سیستم",
      "رفع برخی از باگ های گزارش شده"
    ]
  },
  {
    "backVersion": "24.86.1",
    "frontVersion": 12,
    "date": "1403/01/07",
    "details": [
      "اضافه شدن پنل فیش به ماژول حقوق و دستمزد",
      "اضافه شدن تسویه حساب به ماژول حقوق و دستمزد",
      "تکمیل ثبت سند حقوق و دستمزد",
      "اضافه شدن اتصال به سامانه مودیان تکس پنل",
      "رفع برخی از باگ های گزارش شده"
    ]
  },
  {
    "backVersion": "24.49.1",
    "frontVersion": 11,
    "date": "1402/11/29",
    "details": [
      "اضافه شدن دیگر نوع ها به رسید و حواله انبار مانند: رسید کالای امانی، رسید برگشت از تولید، حواله کالای امانی، حواله مصرف پروژه و غیره"
    ]
  },
  {
    "backVersion": "24.29.1",
    "frontVersion": 10,
    "date": "1402/11/10",
    "details": [
      "صدور فایل بیمه و دارایی و مشاهده تاریخچه فایل های ایجاد شده",
      "امکان طراحی قالب صدور فایل توسط کاربر",
      "دریافت لیست پرسنل از فایل",
      "اعلامیه پرداخت",
      "حذف و اضافه گروهی آیتم های حقوقی",
      "اضافه شدن گزارشات حقوق و دستمزد",
      "چاپ های پیش فرض سیستمی فیش، حکم، بیمه، بانک و غیره"
    ]
  },
  {
    "backVersion": "23.311.1",
    "frontVersion": 9,
    "date": "1402/08/17",
    "details": [
      "اضافه شدن ماژول حقوق و دستمزد"
    ]
  },
  {
    "backVersion": "23.256.1",
    "frontVersion": 8,
    "date": "1402/06/26",
    "details": [
      "اضافه شدن جستجوی کلی",
      "اضافه شدن اسنپ شات دستی برای ذخیره موقت دیتا در کلاینت",
      "اضافه شدن چاپ پیش فرض تراز آزمایشی و مرور حساب",
      "اضافه شدن فونت یکان به طراح چاپ",
      "اضافه شدن افزودن سریع کالا به فاکتور و رسید و حواله",
      "اضافه شدن نگهداری تغییر وضعیت گرید جداول",
      "اضافه شدن قابلیت ثبت مبالغ ارزی در فاکتور",
      "افزایش سرعت نرم افزار در لیست شناورها"
    ]
  },
  {
    "backVersion": "23.179.1",
    "frontVersion": 7,
    "date": "1402/04/08",
    "details": [
      "اضافه شدن بخش ریالی سازی حواله های انبار",
      "فعال شدن قابلیت ویرایش و حذف رسید دائم و تغییر موجودی ابتدای دوره",
      "رفع خطای موجودی منفی در ذخیره فاکتور"
    ]
  },
  {
    "backVersion": "23.158.2",
    "frontVersion": 6,
    "date": "1402/03/17",
    "details": [
      "اضافه شدن چاپ پیش فرض صورتحساب",
      "تغییر روش انتخاب شناورهای کالا در فاکتور",
      "بهبود سرعت درخت حساب ها و شناور ها در تعداد آیتم های زیاد",
      "اصلاح ستون های جدول موجودی ابتدای دوره",
      "قابلیت انتخاب فیلدهای تکمیلی در دریافت از اکسل شناور ها",
      "رفع مشکل بررسی موجودی منفی کالای خدماتی"
    ]
  },
  {
    "backVersion": "23.124.1",
    "frontVersion": 5,
    "date": "1402/0/13",
    "details": [
      "اضافه شدن قابلیت انتقال شناورها همزمان با انتقال حساب ها از دیگر شرکت ها"
    ]
  },
  {
    "backVersion": "23.121.2",
    "frontVersion": 4,
    "date": "1402/02/11",
    "details": [
      "رفع مشکل نمایش شناورهای سطح 2 به بعد در سند انتقال وجه",
      "بهبود مکانیزم دریافت از اکسل های کالا و شناور",
      "اضافه کردن ستون تشخیص به گردش حساب",
      "رفع مشکل خالی نشدن فرم شناور توسط دکمه ذخیره و جدید",
      "رفع مشکل لود پیش فاکتور"
    ]
  },
  {
    "backVersion": "23.117.1",
    "frontVersion": 3,
    "date": "1402/02/06",
    "details": [
      "اضافه شدن گروه سایر به گروه های شناور",
      "اضافه شدن فرم اجازه خروج زمان بسته شدن پنجره های مودال"
    ]
  },
  {
    "backVersion": "23.107.2",
    "frontVersion": 2,
    "date": "1402/01/28",
    "details": [
      "رفع مشکل لود نشدن قیمت در پیش فاکتور",
      "رفع مشکل خطای حساب ها در چک های ابتدای دوره"
    ]
  },
  {
    "backVersion": "23.67.1",
    "frontVersion": 1,
    "date": "1402/01/22",
    "details": [
      "اضافه شدن نمایش لیست تغییرات و به روز رسانی های نرم افزار.",
      "افزایش سرعت جداول .",
      "اضافه شدن گزارشات حسابداری"
    ]
  }
]